import { SHIPMENT_COUNT_URL } from "../constants/url.constant";
import { API } from "../api";

export const REQUEST_INSCAN_SHIPMENT_COUNT_LIST =
  "REQUEST_INSCAN_SHIPMENT_COUNT_LIST";
export const SET_DAILY_SHIPMENT_COUNT_LIST = "SET_DAILY_SHIPMENT_COUNT_LIST";
export const REQUEST_SHIPMENT_COUNT_ORDER_LIST =
  "REQUEST_SHIPMENT_SUMMARY_ORDER_LIST";
export const SET_SHIPMENT_COUNT_ORDER_LIST = "SET_SHIPMENT_COUNT_ORDER_LIST";

/**
 * Get Scan shipment count
 * @param { Object } params to get shipment count
 */
export const getScanShipmentCount = (type, frequency) => {
  return async () => {
    try {
      const res = await API.get(
        SHIPMENT_COUNT_URL + `/${type}?frequency=${frequency}`
      );
      return res;
    } catch (error) {
      console.log(error);
      throw error;
    }
  };
};

/**
 * Get shipment summary orders of specific
 * @param { Object } filter to get shipment summary orders
 */
export const getOrders = (filter) => {
  return async (dispatch) => {
    dispatch({ type: REQUEST_SHIPMENT_COUNT_ORDER_LIST });
    try {
      const res = await API.post(SHIPMENT_COUNT_URL, filter);
      return res;
    } catch (error) {
      console.log(error);
      throw error;
    }
  };
};

const initialState = {
  count: {
    isLoading: false,
    loaded: false,
    columns: [],
    rows: [],
    totalRows: 0
  },
  orders: {
    isLoading: false,
    loaded: false,
    columns: [],
    rows: [],
    totalRows: 0
  }
};

export default function reducer(state = initialState, { type, payload }) {
  switch (type) {
    case REQUEST_INSCAN_SHIPMENT_COUNT_LIST:
      return {
        ...state,
        count: {
          isLoading: true,
          loaded: false
        }
      };
    case REQUEST_SHIPMENT_COUNT_ORDER_LIST:
      return {
        ...state,
        orders: {
          isLoading: true,
          loaded: false
        }
      };
    case SET_SHIPMENT_COUNT_ORDER_LIST:
      return {
        ...state,
        orders: {
          isLoading: false,
          loaded: true,
          columns: payload.columns,
          rows: payload.rows,
          totalRows: payload.count
        }
      };
    case SET_DAILY_SHIPMENT_COUNT_LIST:
      return {
        ...state,
        summary: {
          isLoading: false,
          loaded: true,
          columns: payload.columns,
          rows: payload.rows,
          totalRows: payload.count
        }
      };
    default:
      return state;
  }
}
